<div class="docs-card">

  <div class="doc-insidecard">

    <!-- ================= HEADER ================= -->

    <div class="top-header">

      <div class="header-left">

        <wm-common-text
          class="head-title"
          [data]="{ text: 'Documents' }">
        </wm-common-text>

        <!--
        <wm-common-text
          class="workflow-name"
          [data]="{ text: row?.appNo || '' }">
        </wm-common-text>
        -->

      </div>

      <button
        mat-icon-button
        class="toggle-btn"
        (click)="toggleCard()">

        <mat-icon>
          {{ isOpen ? 'expand_less' : 'expand_more' }}
        </mat-icon>

      </button>

    </div>


    <!-- ================= CONTENT ================= -->

    <div *ngIf="isOpen">

      <!-- ================= SECTION HEADER ================= -->

      <div class="docs-row">

        <wm-common-text
          class="section-title"
          [data]="{ text: 'Inspections Documents' }">
        </wm-common-text>

        <button
          mat-flat-button
          class="upload-btn"
          (click)="onUploadClick()"
          *ngIf="!showUploadSection"
          [disabled]="!inspectionId">

          UPLOAD DOCUMENT

        </button>

      </div>


      <!-- ================= SUBTEXT ================= -->

      <div class="docs-subtext">

        <wm-common-text
          [data]="{
            text: 'Use the upload button to add new documents'
          }">
        </wm-common-text>

      </div>


      <!-- ================= UPLOAD ================= -->

      <div
        class="upload-section"
        *ngIf="showUploadSection">

        <wm-upload
          [validDocumentTypes]="'pdf'"
          [allowMultipleFiles]="false"
          [pathSegments]="[inspectionId]"
          [showUploadedFilesList]="true"
          [deleteStoredDocument]="false"
          [showRemove]="true"
          (uploadComplete)="onUploadComplete($event)">
        </wm-upload>


        <div class="upload-actions">

          <button
            mat-flat-button
            class="cancel-btn"
            (click)="onCancelUpload()">

            CANCEL

          </button>

          <button
            mat-flat-button
            class="save-btn"
            [disabled]="!uploadedDocsBatch.length"
            (click)="onSaveUpload()">

            SAVE

          </button>

        </div>

      </div>


      <!-- ================= COMMON TABLE ================= -->

      <div class="docs-table-container">

        <wm-common-table
          [columns]="columns"
          [data]="documents || []"
          [tableType]="'Staff'"
          [showRowsPerPage]="false"
          [defaultPageSize]="10"
          [pageSize]="10"
          [serverSidePagination]="false"
          [showTotalRecords]="false"
          [fixedColumnWidths]="true"
          tableClass="documents-common-table">
        </wm-common-table>

      </div>

    </div>

  </div>

</div>


<!-- ===================================================== -->
<!-- FILE NAME TEMPLATE                                    -->
<!-- ===================================================== -->

<ng-template
  #fileNameTemplate
  let-doc>

  <ng-container *ngIf="!doc.editing; else editMode">

    <a
      class="doc-link"
      [href]="doc.documentPath"
      target="_blank"
      rel="noopener noreferrer"
      [matTooltip]="doc.documentName"
      matTooltipPosition="above">

      {{ doc.documentName }}

    </a>

  </ng-container>


  <ng-template #editMode>

    <div class="edit-row">

      <input
        type="text"
        class="edit-input"
        [(ngModel)]="editName"
        autofocus />

      <button
        mat-icon-button
        class="icon-btn save-icon"
        (click)="saveDocument(doc)">

        <mat-icon>
          check
        </mat-icon>

      </button>

      <button
        mat-icon-button
        class="icon-btn cancel-icon"
        (click)="cancelEdit(doc)">

        <mat-icon>
          close
        </mat-icon>

      </button>

    </div>

  </ng-template>

</ng-template>


<!-- ===================================================== -->
<!-- UPLOADED ON TEMPLATE                                  -->
<!-- ===================================================== -->

<ng-template
  #uploadedOnTemplate
  let-doc>

  <wm-common-text
    [data]="{
      text: (doc.createdOn | date:'MM/dd/yyyy')
    }">
  </wm-common-text>

</ng-template>


<!-- ===================================================== -->
<!-- UPLOADED BY TEMPLATE                                  -->
<!-- ===================================================== -->

<ng-template
  #uploadedByTemplate
  let-doc>

  <wm-common-text
    [data]="{
      text: doc.modifiedBy || ''
    }">
  </wm-common-text>

</ng-template>


<!-- ===================================================== -->
<!-- ACTIONS TEMPLATE                                      -->
<!-- ===================================================== -->

<ng-template
  #actionsTemplate
  let-doc>

  <button
    mat-button
    class="action-btn"
    [matMenuTriggerFor]="documentActionMenu">

    <wm-common-text
      class="action-text"
      [data]="{ text: 'Action' }">
    </wm-common-text>

  </button>

  <mat-menu #documentActionMenu="matMenu">

    <button
      mat-menu-item
      (click)="editDocument(doc)">

      Edit

    </button>

    <button
      mat-menu-item
      (click)="deleteDocument(doc.id)">

      Delete

    </button>

  </mat-menu>

</ng-template>


<!-- ================= CONFIRMATION ================= -->

<wm-common-confirmation-modal
  [data]="confirmationModalData"
  (onYesClick)="confirmDelete()"
  (onNoClick)="cancelDelete()">
</wm-common-confirmation-modal>
